import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pen-leather",
  "use": "icon-pen-leather-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pen-leather\"><defs><style type=\"text/css\"></style></defs><path d=\"M180.16256 924.28288s237.48608-759.1936 731.91424-728.064c0 0-61.31712 99.28704-216.08448 131.39968 0 0 72.04864 8.78592 130.43712-10.69056 0 0-35.04128 112.92672-225.792 128.47104 0 0 105.12384 27.25888 151.83872 11.6736 0 0-12.67712 84.21376-206.86848 126.03392-11.50976 2.47808-89.02656 21.87264-26.74688 29.67552 0 0 89.51808 15.60576 112.88576 7.80288 0 0-76.65664 114.83136-264.72448 105.10336-18.51392-0.96256-27.27936 0-27.27936 0l-159.58016 198.59456z\" p-id=\"24959\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pen-leather.svg
// module id = 0B+7
// module chunks = 101